import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getWebsite = (state: ApplicationState) => state.context.website;
export const getCurrentLanguage = (state: ApplicationState) => state.context.session.language;
